const sezzleWhite = '#ffffff';
const sezzlePurple = '#382757';
const sezzleSecondaryPurple = '#8333d4';
const sezzleSecondaryAlt = '#af0fda';
const sezzleTertiary = '#786e87';
const transparent = 'transparent';
const headerFont = 'Comfortaa, Open Sans, Helvetica Neue, Helvetica, Arial, cursive, sans-serif';
const bodyFont = 'Nunito Sans, Open Sans, sans-serif';
const backgroundGreen = 'rgba(159, 244, 217, 0.25)';
const backgroundBeige = '#f7f4f0';
const backgroundYellow = 'rgba(254, 165, 0, 0.21)';
const backgroundMint = '#9ff4d9';
const backgroundPeach = 'rgba(251, 162, 142, 0.25)';
const burntOrange = '#d14507';
const backgroundPurple = '#f8f3fc';
const backgroundGrey = 'rgb(229, 229, 229)';
const backgroundTransparent = '#ffffff00';

export const sezzleTheme = {
  backgroundColor: sezzleWhite,
  textColor: sezzlePurple,
  headerFont,
  bodyFont,
  primary: sezzlePurple,
  secondary: sezzleSecondaryPurple,
  secondaryAlt: sezzleSecondaryAlt,
  tertiary: sezzleTertiary,
  primaryButton: sezzlePurple,
  primaryButtonText: sezzleWhite,
  primaryButtonBorder: transparent,
  primaryButtonHover: sezzleWhite,
  primaryButtonTextHover: sezzleSecondaryPurple,
  primaryButtonBorderHover: sezzleSecondaryPurple,
  secondaryButton: sezzleWhite,
  secondaryButtonTextColor: sezzleSecondaryPurple,
  secondaryButtonBorder: sezzleSecondaryPurple,
  secondaryButtonHover: sezzleSecondaryPurple,
  secondaryButtonTextColorHover: sezzleWhite,
  secondaryButtonBorderHover: transparent,
  linkColor: sezzleSecondaryPurple,
  linkColorHover: sezzleSecondaryAlt,
  backgroundColors: {
    backgroundGreen,
    backgroundBeige,
    backgroundYellow,
    backgroundMint,
    backgroundPeach,
    backgroundPurple,
    backgroundGrey,
    backgroundTransparent,
  },
  headerColors: {
    sezzlePurple,
    burntOrange,
  },
  buttonFont: bodyFont,
  secondaryLinkColor: sezzleWhite,
  secondaryLinkActive: backgroundMint,
  footerBackground: backgroundBeige,
};

export default sezzleTheme;
